import { TextArea } from "@faire/web/slate/Input/TextArea";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { CONTACT_CARDS_COMBINED_WIDTH } from "../../consts";
var CHARACTERS_LIMIT = 500;
export var OpenReasonTextArea = function OpenReasonTextArea(_ref) {
  var visibleWhen = _ref.visibleWhen,
    value = _ref.value,
    _onChange = _ref.onChange;
  if (!visibleWhen) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(TextAreaPurposeMessage, null), /*#__PURE__*/React.createElement(TextArea, {
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    maxLength: CHARACTERS_LIMIT,
    "data-test-id": "csat-open-text-area"
  }));
};
var TextAreaPurposeMessage = function TextAreaPurposeMessage() {
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "labelSansRegular",
    style: {
      marginBottom: getSpacing("1x")
    }
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "DVFD14",
    defaultMessage: [{
      "type": 0,
      "value": "Deel hier je feedback over je supportervaring. Voor alle andere problemen kun je contact met ons opnemen via bovenstaande opties."
    }]
  }));
};
var Wrapper = styled.div.withConfig({
  displayName: "OpenReasonTextArea__Wrapper"
})(["margin-top:", ";width:100%;", "{width:", ";}textarea{min-height:150px;}"], getSpacing("2x"), responsiveMediaQueries.tabletAndAbove, CONTACT_CARDS_COMBINED_WIDTH);